import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DevicesService } from '../../../../app/core/routing/services/devices/devices.service';
import { DevicesConstants } from '../../../../../src/app/core/routing/services/devices/constants/devices.constants';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CommonService } from '../../../common/services/common.service';
import { WebsocketService } from '../../../core/routing/services/websocket/websocket.service';
import { PendingUserConstants } from '../../../core/routing/services/pendingUsers/constants/pendingUsers.constant';
import { SpinnerInterceptor } from '../../../core/routing/interceptors/spinner.interceptor';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { AssetLibraryConstants } from 'src/app/core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from 'src/environments/environment';
import moment from 'moment';
import { User } from '../../account/login/_models/user.model';
import { ActiveUserConstants } from '../../../../../src/app/core/routing/services/activeusers_api/constatnts/activeusers.constant';
import { RetailStoreCommonConstants } from '../../../../../src/app/common/constants/retailer-store.constant';
import { StoresConstant } from '../../../../../src/app/core/routing/services/stores_api/constants/stores.constant';
import { RetailStoreConstants } from '../../../../app/core/routing/services/retail_api/constants/retailHq.constants'
import { AppGlobal } from '../../../../../src/app/core/state/app-global';

@Component({
  selector: 'iposcen-active-device-report',
  templateUrl: './active-device-report.component.html',
  styleUrls: ['./active-device-report.component.scss']
})
export class ActiveDeviceReportComponent implements OnInit {
  @ViewChild('searchValue') animateThis: ElementRef;
  allUserscsvData = [];
  isLoading = false;
  globConst = GlobalConstants;
  storeName = sessionStorage.getItem('storeName');
  storeId = sessionStorage.getItem('storeID');
  retailerID = sessionStorage.getItem(GlobalConstants.RETAILERID);
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  downloadMultipleReports = DevicesConstants.DOWNLOAD_MULTIPLE_REPORTS;
  downloadFullReport = DevicesConstants.DOWNLOAD_FULL_REPORTS;
  downloadFullReportTooltip = GlobalConstants.DOWNLOAD_FULL_REPORT;
  activeDevices = DevicesConstants.ACTIVE_DEVICES;
  btnTextGenerate = GlobalConstants.GENERATE;
  btnTextYes = GlobalConstants.YESS;
  displayActiveuser = [];
  pageNumber = 1;
  showFrom: number;
  showTo: number;
  tableSize: number;
  paginationCount: number;
  totalPages: number;
  maxSize = 5;
  page: number;
  totalDeviceCount: number;
  totalStoreCount: number;
  devicerequestBody;
  validData: number;
  isSelected = new Map();
  selectedIdList = [];
  preLoadSelect = [];
  enteredSearchData: string;
  sortType: string;
  sort = 'asc';
  isSearchActive = false;
  showRetailGif = false;
  isGenerate = false;
  searchPlaceHolderText = GlobalConstants.SEARCHPLACEHOLDER;
  isSelectGenerate = false;
  download: string;
  generate: string;
  generating: string;
  deviceLastGenerated: any;
  deviceDownloadUrlReport: string;
  deviceStatusReport: string;
  reportDownloadType: string;
  showdownloadReport: string;
  checkStatus: boolean;
  openFullReportPopup = false;
  openIndividualPopup = false;
  generatedTimeStamp: any;
  covertedTodayDate: any;
  isIndividualReport = false;
  isFullReport = false;
  selectedId: any;
  isGenerateSelectedClicked = false;
  filterString: string;
  selectFilterQueue = {};
  searchQueue = {};
  sortQueue = {};
  globalSortValue: string;
  globalSortBy: string;
  isReportDataEmpty: boolean = false;
  searchClose = false;
  searchData: string;
  loadFlag: string;
  searchTag: string;
  dateFormatter = DevicesConstants.DATE_FORMATTER;
  url = environment.apiBaseUrl + AssetLibraryConstants.SLASH;
  isAllReportDataSelected = false;
  allReportData = [];
  isMasterSel = false;
  isAllSelectedFlag = false;
  deviceConst = DevicesConstants;
  isNoStoreExists = false;
  isEnglish = localStorage.getItem('preferredLanguage') === 'en-US';
  isItalian = localStorage.getItem('preferredLanguage') === 'it';
  isPortugese_Brazil = localStorage.getItem('preferredLanguage') === 'pt-br';
  isPortugese_Portugal = localStorage.getItem('preferredLanguage') === 'pt';
  isRomanian = localStorage.getItem('preferredLanguage') === 'ro';
  isRussian = localStorage.getItem('preferredLanguage') === 'ru';
  isSpanish_Mexico = localStorage.getItem('preferredLanguage') === 'es-mx';
  isSpanish = localStorage.getItem('preferredLanguage') === 'es';
  isUkranian = localStorage.getItem('preferredLanguage') === 'uk';
  retailerConfig: any;
  userId: string;
  retailerId: string;
  isUnisonDemoEnabled: boolean;
  changePlacement: boolean;
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  private ngUnsubscribe = new Subject();
  constructor(private appGlobal: AppGlobal, private devicesService: DevicesService, private cmnService: CommonService, private websocketService: WebsocketService,
    private spinnerInterceptor: SpinnerInterceptor, private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    this.page = 1;
    this.tableSize = 10;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize);
    this.totalDeviceCount = 0;
    this.totalStoreCount = 0;
    if (this.userRole === GlobalConstants.INTEL_ADMIN) this.isUnisonDemoEnabled = true;
    else if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ) {
      this.userId = sessionStorage.getItem(GlobalConstants.USER_ID);
      this.retailerId = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
      this.appGlobal.$userAccount
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(async (userAccount: User) => {
          this.retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.cmnService.getRetailerConfig(this.userId, this.retailerId);
          this.isUnisonDemoEnabled = this.retailerConfig?.enableUnisonDemo ? this.retailerConfig?.enableUnisonDemo : false;
        });
    }
    this.getActiveReportData();
    this.globalSortBy = DevicesConstants.LASTGENERATED;
    this.globalSortValue = DevicesConstants.DESCENDING_ORDER;
    this.download = GlobalConstants.DOWNLOAD;
    this.generate = GlobalConstants.GENERATE;
    this.generating = GlobalConstants.GENERATING;
    this.loadFlag = StoresConstant.LOAD_FLAG;
    this.devicerequestBody = {
      csvHeaders: [
        GlobalConstants.RETAILER_NAME_SEARCH,
        GlobalConstants.ACTIVE_USRS_RETLR_ID,
        GlobalConstants.STORE_NAME_HEADING,
        GlobalConstants.STORE_ID,
        GlobalConstants.STORE_NUMBER,
        GlobalConstants.STORE_STATE,
        GlobalConstants.SKU_CODE,
        GlobalConstants.DEVICE_UUID,
        GlobalConstants.DEVICE_NAME,
        GlobalConstants.BRAND_CAPS,
        GlobalConstants.DEVICE_TYPE,
        GlobalConstants.OS,
        GlobalConstants.PROCESSOR,
        GlobalConstants.CONNECTIVITY_STATUS,
        GlobalConstants.DATE_CONNECTED,
        GlobalConstants.PROCESSOR_MODEL,
        GlobalConstants.SEGMENT_CSV,
        GlobalConstants.PROMO_1,
        GlobalConstants.PROMO_2,
        GlobalConstants.PROMO_3,
        GlobalConstants.CONTENT_TYPE,
        GlobalConstants.TOUCHLESS_QR_CODE,
        GlobalConstants.IPOS_VERSION,
        GlobalConstants.MEMORY_CSV,
        GlobalConstants.STORAGE,
        GlobalConstants.DISPLAY,
        GlobalConstants.BATTERY,
      ]
    };
    if (this.isUnisonDemoEnabled) {
      this.devicerequestBody.csvHeaders.push(GlobalConstants.UNISONDEMO_VERSION);
      this.devicerequestBody.csvHeaders.push(GlobalConstants.UNISONDEMO_IOSVERSION);
      this.devicerequestBody.csvHeaders.push(GlobalConstants.UNISONDEMO_ANDROIDVERSION);
    }

    // commenting code for srt or pc finder 
    //if (this.userRole === 'intelAdmin') {
      //this.devicerequestBody.csvHeaders.push(DevicesConstants.SRT_VERSION_TEXT);
    //}
    this.devicerequestBody.csvHeaders.push(GlobalConstants.PROCESSOR_GENERATION); //IIT2-11088
    if (this.userRole === GlobalConstants.INTEL_ADMIN) 
     {this.devicerequestBody.csvHeaders.push(GlobalConstants.BATTLE_STATION_DEVICES);}//IIT3-1379
    // ---- IIT2-18582 ------->
    if (this.userRole === GlobalConstants.INTEL_ADMIN || this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ){
     this.devicerequestBody.csvHeaders.push(GlobalConstants.IPOS_LEGAL_VERSION);
     this.devicerequestBody.csvHeaders.push(GlobalConstants.DEFAULT_LANGUAGE);
    }
    this.cmnService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data) {
          this.showRetailGif = true;
        }
      });
  }
  onTableDataChange(event) {
    this.isAllReportDataSelected = false;
    this.page = event;
    this.getActiveReportData();
  }

  getReportFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.selectFilterQueue || this.searchQueue || this.sortQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
      if (this.searchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      if (this.sortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
    }
    this.getActiveReportData();
  }

  searchActiveDeviceReport(searchData) {
    this.searchClose = true;
    if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
      this.searchTag = RetailStoreConstants.SEARCH_BY;
      this.loadFlag = StoresConstant.UNLOAD_FLAG;
    }
    if (searchData && this.searchTag) {
      this.searchQueue = {};// To clear previous seletion
      this.searchQueue[this.searchTag] = searchData;
      this.getReportFilterSearchData();
    } else {
      this.getActiveReportData();
      this.page = 1;
    }
  }

  searchReportOnEnter(searchData) {
    this.animateThis.nativeElement.blur();
    this.searchActiveDeviceReport(searchData);
  }

  clearReportSearch(val: string) {
    if (val?.length === 0 && this.searchClose) {
      this.searchClose = false;
      this.searchQueue = {};
      this.getReportFilterSearchData();
      this.searchData = ActiveUserConstants.EMPTY_VALUE;
      this.showFrom = this.page = 1;
      this.showTo = 10;
    }
  }

  getActiveReportData() {
    this.checkStatus = true;
    this.websocketService.deviceReportWebSocketURL
      .subscribe(getAllActiveDevice => {
        if (this.checkStatus && getAllActiveDevice) {
          this.devicesService.getActiveDeviceReport(this.globalSortBy, this.globalSortValue, this.page, this.filterString, this.retailerID)
            .subscribe(resp => {
            },
              error => {
                this.isReportDataEmpty = true;
              });
          this.checkStatus = false;
        }
        if (getAllActiveDevice['device'] && !this.isAllReportDataSelected) {
          this.spinnerInterceptor.setSpinnerLoad(false);
          if (getAllActiveDevice['device']['deviceReport']) {
            if (this.userRole === 'intelAdmin') {
              this.totalDeviceCount = getAllActiveDevice['device']['deviceReport'].totalDeviceCount;
              this.totalStoreCount = getAllActiveDevice['device']['deviceReport'].totalStoreCount;
              this.displayActiveuser = getAllActiveDevice['device']['deviceReport'].retailer;
              this.validDataCount('retailerId');
            } else {
              this.totalDeviceCount = getAllActiveDevice['device']['deviceReport'].totalDeviceCount;
              this.totalStoreCount = getAllActiveDevice['device']['deviceReport'].totalStoreCount;
              this.displayActiveuser = getAllActiveDevice['device']['deviceReport'].stores;
              this.isNoStoreExists = this.displayActiveuser.some(ele => ele.storeId === this.deviceConst.NO_STORE_ID);
              this.validDataCount('storeId');
            }
          }
          this.isReportDataEmpty = (this.displayActiveuser.length === 0) || false;
          this.deviceLastGenerated = getAllActiveDevice['device'].lastGeneratedTime;
          this.deviceDownloadUrlReport = getAllActiveDevice['device'].deviceDownloadURL;
          this.deviceStatusReport = getAllActiveDevice['device'].deviceStatus;
          this.reportDownloadType = getAllActiveDevice['device'].reportDownloadType
          if (this.deviceStatusReport === 'generating' && this.reportDownloadType === 'multi') this.isGenerateSelectedClicked = true;
          else if (this.deviceStatusReport === 'generating' && this.reportDownloadType === 'full') {
            this.isGenerateSelectedClicked = false;
            this.isSelected.clear();
            this.selectedIdList = [];
          }
          if (this.deviceDownloadUrlReport) {
            this.showdownloadReport = this.url + this.deviceDownloadUrlReport + '.' + 'csv';
          }
          if (this.userRole !== 'storeUser') {
            this.paginationCount = (getAllActiveDevice['device'].paginationContext.totalItems);
            this.totalPages = (getAllActiveDevice['device'].paginationContext.totalPages);
            this.showFrom = ((this.page - 1) * this.tableSize) + 1;
            this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
          }
        }
        this.cmnService.setRetailGifValue(false);
      }, error => {
        this.isReportDataEmpty = true;
      });
    this.websocketService.deviceReportWebSocketURL.next({
      "userID": sessionStorage.getItem(PendingUserConstants.USER_ID)
    });
  }

  downloadIndividualReport(data) {
    window.open(this.url + `${data.deviceDownloadURL}` + '.' + 'csv')
  }
  validDataCount(id: string) {
    this.validData = 0;
    //this.isSelected.clear();
    this.preLoadSelect = [];
    this.displayActiveuser.forEach(res => {
      if (res.storeDeviceCount > 0) {
        this.preLoadSelect.push([res[id], true]);
        this.validData += 1;
      }
    });

  }
  isAllSelectedEnabeled(event) {
    this.isGenerateSelectedClicked = false;
    if (event) {
      this.isAllReportDataSelected = true;
      this.devicesService.getAllSelectedActiveDeviceReport()
        .subscribe(res => {
          if (this.userRole === GlobalConstants.INTEL_ADMIN) {
            this.allReportData = res['device']['device']['deviceReport'].retailer;
          } else if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ || this.userRole === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE) {
          this.allReportData = res['device']['device']['deviceReport'].stores;
          }
          this.allReportData.forEach(value => {
            if (this.userRole === GlobalConstants.INTEL_ADMIN) {
              this.isSelected.set(value.retailerId, value);
            } else if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ || this.userRole === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE) {
              this.isSelected.set(value.storeId, value);
            }
          });
          let selectAllList = Array.from(this.isSelected.values());
          this.isMasterSel = selectAllList.length === this.paginationCount;
          this.isAllReportDataSelected = false;
        });
      //this.isSelected = new Map(this.preLoadSelect);
    } else {
      this.isSelected.clear();
    }
  }
  downloadCsv(csvResponse) {
    this.allUserscsvData = csvResponse;
    const todayTime = new Date();
    const month = (todayTime.getMonth() + 1);
    const day = (`0${todayTime.getDate()}`).slice(-2);
    const year = todayTime.getFullYear();
    const filename = GlobalConstants.DEVICE_CSV_FILENAME;
    const userfilename = month + '_' + day + '_' + year + '_' + filename;;
    const blob = new Blob([`\ufeff${String(this.allUserscsvData)}`], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', `${userfilename}.csv`);
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  getSelectedReport(data) {
    this.isGenerateSelectedClicked = false;
    this.isMasterSel = false;
    this.isAllSelectedFlag = false;
    if (this.userRole === 'intelAdmin') {
      if (this.isSelected.has(data.retailerId)) {
        this.isSelected.delete(data.retailerId);
      } else {
        this.isSelected.set(data.retailerId, true);
      }
    } else {
      if (this.isSelected.has(data.storeId)) {
        this.isSelected.delete(data.storeId);
      } else {
        this.isSelected.set(data.storeId, true);
      }
    }
    this.retainSelection(this.isSelected);
    if (this.selectedIdList.length > 0) this.retainSelection(this.isSelected);
  }

  retainSelection(data) {
    const changedArray = Array.from(data.keys());
    changedArray.sort();

    if(this.paginationCount === changedArray.length)
    {
      this.isAllSelectedFlag = true;
    } else {
      this.isAllSelectedFlag = false;
    }
    this.selectedIdList.sort();
    let isEqual = this.selectedIdList.length === changedArray.length && this.selectedIdList.every((value, i) => value === changedArray[i]);
    if (isEqual) this.isGenerateSelectedClicked = true;
  }

  generateSelectedReports() {
    const selectedArray = Array.from(this.isSelected.keys());
    this.selectedIdList = selectedArray;
    const selectedString = selectedArray.toString();
    this.generateSelectedReport(selectedString);
  }

  generateSelectedReport(id) {
    if (id.retailerId || id.storeId) {
      if (this.userRole === 'intelAdmin') {
        id = id.retailerId;
      } else {
        id = id.storeId;
      }
    }
    this.isSelectGenerate = true;
    setTimeout(() => {
      this.isSelectGenerate = false;
      if (!this.isSelectGenerate) {
        if (navigator.onLine) {
          this.devicesService.reportDownloadById(this.devicerequestBody, id, this.retailerID, this.isUnisonDemoEnabled)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(getAllDevicesResponse => {
              setTimeout(() => {
                this.spinnerInterceptor.setSpinnerLoad(true);
              }, 0);
            });
        }
      }
    }, 3000);
  }

  generateFullReports() {
    this.isAllSelectedFlag = false;
    this.isSelectGenerate = true;
    setTimeout(() => {
      this.isSelectGenerate = false;
      if (!this.isSelectGenerate) {
        if (navigator.onLine) {
          this.devicesService.fullReportDownload(this.devicerequestBody, this.retailerID, this.storeId, this.isUnisonDemoEnabled)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(getAllDevicesResponse => {
              setTimeout(() => {
                this.spinnerInterceptor.setSpinnerLoad(true);
                this.isMasterSel = false;
              }, 0);
            });
        }
      }
    }, 3000);
  }

  downloadSelectedReports() {
    window.open(this.showdownloadReport);
    this.googleAnalyticsService.downloadFullReport('Download selected reports');
  }

  downloadIndividualFullReport(data, type) {
    this.covertedTodayDate = new Date();
    if (type === 'downloadFull') {
      const inputFullReportDate = new Date(this.deviceLastGenerated);
      if (inputFullReportDate.setHours(0, 0, 0, 0) === this.covertedTodayDate.setHours(0, 0, 0, 0)) {
        window.open(this.showdownloadReport);
        this.googleAnalyticsService.downloadFullReport('Download full reports'); // IIT2-5312
      } else {
        this.openFullReportPopup = true;
        this.isFullReport = true;
        this.isIndividualReport = false;
        this.generatedTimeStamp = moment(this.deviceLastGenerated).format(GlobalConstants.DATE_FORMAT);
      }
    }
    else if (type === 'individual') {
      this.selectedId = data;
      const inputIndividualDate = (data.storeId === 'stNstore') ? new Date(data.lastGeneratedTimeNoStore) : new Date(data.lastGeneratedTime);
      if (inputIndividualDate.setHours(0, 0, 0, 0) === this.covertedTodayDate.setHours(0, 0, 0, 0)) {
        const downloadURL = (data.storeId === 'stNstore') ? data.deviceDownloadURLNoStore : data.deviceDownloadURL;
        window.open(this.url + `${downloadURL}` + '.' + 'csv');
        this.googleAnalyticsService.downloadFullReport('Download individual report');
      } else {
        this.openFullReportPopup = true;
        this.isIndividualReport = true;
        this.isFullReport = false;
        // this.selectedId = data;
        const lastGenTime = (data.storeId === 'stNstore') ? data.lastGeneratedTimeNoStore : data.lastGeneratedTime;
        this.generatedTimeStamp = moment(lastGenTime).format(GlobalConstants.DATE_FORMAT);        
      }
    }
  }

  closeDownloadPopup() {
    this.openFullReportPopup = false;
  }

  downloadOldReports() {
    if (this.isFullReport) {
      window.open(this.showdownloadReport);
      this.googleAnalyticsService.downloadFullReport('Download old reports'); // IIT2-5312
    } else if (this.isIndividualReport) {
      window.open(this.url + `${this.selectedId.deviceDownloadURL}` + '.' + 'csv')
    }
    this.openFullReportPopup = false;
  }

  regenerateFullReport() {
    if (this.isFullReport) {
      this.generateFullReports();
    } else if (this.isIndividualReport) {
      this.generateSelectedReport(this.selectedId)
    }
    this.openFullReportPopup = false;
  }

  sortingTableWithAscandDesc(tempval: string) {
    this.globalSortValue = this.globalSortValue !== ActiveUserConstants.ASCENDING_ORDER ? ActiveUserConstants.ASCENDING_ORDER :
      RetailStoreCommonConstants.DESCENDING_ORDER;
    this.globalSortBy = tempval;
    this.getReportFilterSearchData();
  }

  sortActiveDevice(sortKey: string) {
    switch (sortKey) {
      case (DevicesConstants.STORE_NAME_SORT):
        this.sortingTableWithAscandDesc(DevicesConstants.STORE_NAME_SORT);
        break;
      case (DevicesConstants.RETAILERNAME):
        this.sortingTableWithAscandDesc(DevicesConstants.RETAILERNAME);
        break;
      case (DevicesConstants.STOREDEVICECOUNT):
        this.sortingTableWithAscandDesc(DevicesConstants.STOREDEVICECOUNT);
        break;
      case (DevicesConstants.GENERATEDBY):
        this.sortingTableWithAscandDesc(DevicesConstants.GENERATEDBY);
        break;
      case (DevicesConstants.LASTGENERATED):
        this.sortingTableWithAscandDesc(DevicesConstants.LASTGENERATED);
        break;
      case (DevicesConstants.STORECOUNT):
        this.sortingTableWithAscandDesc(DevicesConstants.STORECOUNT);
        break;
      default: {
      }
    }
  }

  setDisplay(res) {
    if (this.userRole === 'intelAdmin') {
      this.totalDeviceCount = res.device[0].totalDeviceCount;
      this.totalStoreCount = res.device[0].totalStoreCount;
      this.displayActiveuser = res.device[0].retailer;
      this.validDataCount('retailerId');
    } else {
      this.totalDeviceCount = res.devices[0].totalDeviceCount;
      this.totalStoreCount = res.devices[0].totalStoreCount;
      this.displayActiveuser = res.devices[0].stores;
      this.validDataCount('storeId');
    }
  }

  generateReport() {
    this.isSelectGenerate = true;
    setTimeout(() => {
      this.isSelectGenerate = false;
    }, 3000);
  }

  ClickedOut(event) {
    if (event.target.className === "device-popup-outside") {
      this.isSelectGenerate = false;
    }
  }

  // For IIT2-8012 user story and adding below methods to check multiple conditions for ngClass.
  checkGenerateStatus(data) {
    if (data?.storeId !== this.globConst.NO_STORE_ID) {
      return data?.deviceStatus === '' || data?.deviceStatus === null || data?.deviceStatus === this.deviceConst.GENERATE_STATUS
        ? this.deviceConst.GENERATE_POP_OVER_CLASS : this.deviceConst.PROFILES_HIDE_CLASS;
    } else if (data?.storeId === this.globConst.NO_STORE_ID) {
      return data?.deviceStatusNoStore === '' || data?.deviceStatusNoStore === null || data?.deviceStatusNoStore === this.deviceConst.GENERATE_STATUS
        ? this.deviceConst.GENERATE_POP_OVER_CLASS : this.deviceConst.PROFILES_HIDE_CLASS;
    }
  }

  checkgeneratingStatus(data) {
    if (data?.storeId !== this.globConst.NO_STORE_ID) {
      return data?.deviceStatus === this.deviceConst.GENERATING_STATUS
        ? this.deviceConst.EXISTING_PROFILES_CLASS : this.deviceConst.PROFILES_HIDE_CLASS;
    } else if (data?.storeId === this.globConst.NO_STORE_ID) {
      return data?.deviceStatusNoStore === this.deviceConst.GENERATING_STATUS
        ? this.deviceConst.EXISTING_PROFILES_CLASS : this.deviceConst.PROFILES_HIDE_CLASS;
    }
  }

  checkDownloadStatus(data) {
    if (data?.storeId !== this.globConst.NO_STORE_ID) {
      return data?.deviceStatus === this.deviceConst.GENERATE_STATUS
        ? this.deviceConst.PROFILES_DOWNLOAD_CLASS : this.deviceConst.PROFILES_HIDE_CLASS;
    } else if (data?.storeId === this.globConst.NO_STORE_ID) {
      return data?.deviceStatusNoStore === this.deviceConst.GENERATE_STATUS
        ? this.deviceConst.PROFILES_DOWNLOAD_CLASS : this.deviceConst.PROFILES_HIDE_CLASS;
    }
  }
  //  IIT2-8012 ends
}
